import {verifiedFetch} from '@github-ui/verified-fetch'
import {Banner} from '@primer/react'
import type {ReactNode, Ref} from 'react'
import {useState} from 'react'
import styles from './IpmBannerBase.module.css'

export interface IpmBannerBaseProps {
  dismissPath: string
  visibleEvent: string
  dismissEvent: string
  testId: string
  title: string
  icon?: ReactNode
  description: ReactNode
  primaryAction?: ReactNode
  variant?: 'critical' | 'info' | 'success' | 'upsell' | 'warning'
  rounded?: boolean
  location: string
  ref?: Ref<HTMLDivElement>
}

export function IpmBannerBase({
  dismissPath,
  visibleEvent,
  dismissEvent,
  testId,
  title,
  icon,
  description,
  primaryAction,
  variant,
  rounded,
  location,
  ref,
}: IpmBannerBaseProps) {
  const [hidden, setHidden] = useState<boolean>(false)
  const isRounded = rounded ?? location !== 'global'

  const handleDismiss = async () => {
    try {
      await verifiedFetch(dismissPath, {method: 'POST'})
    } catch {
      // Silently handle network errors to maintain a good UX
    } finally {
      setHidden(true)
    }
  }

  if (hidden) {
    return null
  }

  const supportsCustomIcon = !variant || variant === 'info' || variant === 'upsell'

  return (
    <div
      ref={ref}
      tabIndex={-1}
      data-hpc
      data-testid={testId}
      data-analytics-event={dismissEvent}
      data-analytics-visible={visibleEvent}
    >
      <Banner
        title={title}
        hideTitle
        icon={supportsCustomIcon ? icon : undefined}
        variant={variant}
        data-testid={`${testId}-inner`}
        className={isRounded ? undefined : styles.squareBanner}
        description={description}
        primaryAction={primaryAction}
        onDismiss={handleDismiss}
      />
    </div>
  )
}
